import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {FloorPlanEditorRoutingModule} from './floor-plan-editor-routing.module';
import {FloorPlanEditorComponent} from './containers/floor-plan-editor/floor-plan-editor.component';
import {FloorPlanEditorHeaderComponent} from './components/floor-plan-editor-header/floor-plan-editor-header.component';
import {LogoModule} from '../vision/logo/logo.module';
import {IconModule} from '../vision/icon';
import {ButtonModule} from '../vision/button';
import {FloorPlanEditorMainComponent} from './containers/floor-plan-editor-main/floor-plan-editor-main.component';
import {FloorPlanEditorSidebarComponent} from './containers/floor-plan-editor-sidebar/floor-plan-editor-sidebar.component';
import {FloorPlanEditorSidebarHeaderComponent} from './components/floor-plan-editor-sidebar-header/floor-plan-editor-sidebar-header.component';
import {CreateFloorDialogComponent} from './components/create-floor-dialog/create-floor-dialog.component';
import {SharedModule} from '../shared';
import {InputModule} from '../vision/input';
import {reducers} from './reducers';
import {StoreModule} from '@ngrx/store';
import {FloorPlanImageEmptyComponent} from './components/floor-plan-image-empty/floor-plan-image-empty.component';
import {FloorPlanEditorMapComponent} from './components/floor-plan-editor-map/floor-plan-editor-map.component';
import {DraggableDeviceMarkerComponent} from './components/draggable-device-marker/draggable-device-marker.component';
import {FloorPlanEditorTopComponent} from './containers/floor-plan-editor-top/floor-plan-editor-top.component';
import {EffectsModule} from '@ngrx/effects';
import {FloorPlanEditorDeviceMarkerEffects} from './effects/floor-plan-editor-device-marker.effects';
import {FloorPlanEditorDeviceListComponent} from './components/floor-plan-editor-device-list/floor-plan-editor-device-list.component';
import {FloorPlanSharedModule} from '../floor-plan-shared/floor-plan-shared.module';
import {DragAndDropModule} from '../drag-and-drop/drag-and-drop.module';
import {ImageUploaderComponent} from './components/image-uploader/image-uploader.component';
import {FloorPlanEditorViewEffects} from './effects/floor-plan-editor-view.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('floor-plan-editor', reducers),
    EffectsModule.forFeature([
      FloorPlanEditorDeviceMarkerEffects,
      FloorPlanEditorViewEffects
    ]),
    FloorPlanSharedModule,
    FloorPlanEditorRoutingModule,
    LogoModule,
    IconModule,
    ButtonModule,
    InputModule,
    DragAndDropModule,
    // For FormsModule
    SharedModule
  ],
  exports: [
    FloorPlanEditorComponent,
    FloorPlanEditorHeaderComponent,
    FloorPlanEditorMainComponent,
    FloorPlanEditorSidebarComponent,
    FloorPlanEditorSidebarHeaderComponent,
    CreateFloorDialogComponent,
    FloorPlanImageEmptyComponent,
    FloorPlanEditorMapComponent,
    DraggableDeviceMarkerComponent,
    FloorPlanEditorTopComponent,
    FloorPlanEditorDeviceListComponent,
    ImageUploaderComponent
  ],
  declarations: [
    FloorPlanEditorComponent,
    FloorPlanEditorHeaderComponent,
    FloorPlanEditorMainComponent,
    FloorPlanEditorSidebarComponent,
    FloorPlanEditorSidebarHeaderComponent,
    CreateFloorDialogComponent,
    FloorPlanImageEmptyComponent,
    FloorPlanEditorMapComponent,
    DraggableDeviceMarkerComponent,
    FloorPlanEditorTopComponent,
    FloorPlanEditorDeviceListComponent,
    ImageUploaderComponent
  ],
  entryComponents: [
    FloorPlanEditorComponent,
    CreateFloorDialogComponent,
    DraggableDeviceMarkerComponent
  ]
})

export class FloorPlanEditorModule {
}
